import { useRouter } from 'next/router';
import { CmsSlot, isServer } from '@storefront/lib-global';
import { SearchContextProvider } from '@storefront/lib-global/context/searchContext';
import { AlgoliaConfigure } from '@storefront/lib-global/globalComponents/algolia/AlgoliaConfigure';
import { createAlgoliaServerState } from '@storefront/lib-global/utils/algoliaFilterUtils';
import { CMS_SLOTS_DELIVERY_KEYS } from '@storefront/lib-global/utils/amplience';
import { PLPLayout } from '@storefront/lib-products/products-listing/components/PLPLayout';
import type { PLPLayoutProps } from '@storefront/lib-products/products-listing/components/PLPLayout';

type ProductCategoryProps = PLPLayoutProps & {
  locale?: string;
  serverUrl?: string;
};
export function ProductCategory({
  locale,
  products,
  category,
  handlebarComponents,
  plpLayout,
  serverUrl,
  isMobile,
}: ProductCategoryProps) {
  const { query } = useRouter();
  const serverState = createAlgoliaServerState({
    locale,
    query,
    products: products as unknown as { [key: string]: unknown },
  });
  const pageSizeNumber = parseInt(query?.pageSize as string, 10);

  return (
    <SearchContextProvider serverState={serverState} serverUrl={serverUrl}>
      <AlgoliaConfigure
        filters={category ? `categories.key:${category.key}` : undefined}
        hitsPerPage={!isNaN(pageSizeNumber) ? pageSizeNumber : undefined}
        clickAnalytics={!isServer()}
        analytics={!isServer()}
      />
      <CmsSlot deliveryKey={CMS_SLOTS_DELIVERY_KEYS.PLP_TOP_SKINNY_BANNER} />
      <PLPLayout
        category={category}
        products={products}
        plpLayout={plpLayout}
        handlebarComponents={handlebarComponents}
        query={query}
        isMobile={isMobile}
      />
    </SearchContextProvider>
  );
}
